const general = {
    placeholder: 'ตัวยึดตำแหน่ง',
    submit: 'ส่ง',
    skip: 'ข้าม',
    next: 'ถัดไป',
    back: 'ย้อนกลับ',
    retry: 'ลองอีกครั้ง',
    done: 'เสร็จสิ้น',
    search: 'ค้นหา',
    search_placeholder: 'ค้นหา',
    clear_result: 'ล้างผลลัพธ์',
    save: 'บันทึก',
    save_changes: 'บันทึกการเปลี่ยนแปลง',
    saved: 'บันทึกแล้ว',
    discard: 'ละทิ้ง',
    download: 'ดาวน์โหลด',
    loading: 'กำลังโหลด...',
    redirecting: 'กำลังเปลี่ยนเส้นทาง...',
    add: 'เพิ่ม',
    added: 'เพิ่มแล้ว',
    cancel: 'ยกเลิก',
    confirm: 'ยืนยัน',
    check_out: 'ชำระเงิน',
    create: 'สร้าง',
    set_up: 'ตั้งค่า',
    customize: 'ปรับแต่ง',
    enable: 'เปิดใช้งาน',
    reminder: 'เตือนความจำ',
    edit: 'แก้ไข',
    delete: 'ลบ',
    deleted: 'ลบแล้ว',
    activate: 'เปิดการใช้งาน',
    deactivate: 'ปิดการใช้งาน',
    more_options: 'ตัวเลือกเพิ่มเติม',
    close: 'ปิด',
    copy: 'คัดลอก',
    copying: 'กำลังคัดลอก',
    copied: 'คัดลอกแล้ว',
    required: 'จำเป็น',
    add_another: 'เพิ่มอีกหนึ่ง',
    create_another: 'สร้างอีกหนึ่ง',
    deletion_confirmation: 'คุณแน่ใจหรือว่าต้องการลบ {{title}} นี้?',
    settings_nav: 'การตั้งค่า',
    unsaved_changes_warning: 'คุณได้ทำการเปลี่ยนแปลงบางอย่าง คุณแน่ใจหรือว่าจะออกจากหน้านี้?',
    leave_page: 'ออกจากหน้านี้',
    stay_on_page: 'อยู่ในหน้านี้',
    type_to_search: 'พิมพ์เพื่อค้นหา',
    got_it: 'รับทราบ',
    continue: 'ดำเนินการต่อ',
    page_info: '{{min, number}}-{{max, number}} จากทั้งหมด {{total, number}}',
    learn_more: 'เรียนรู้เพิ่มเติม',
    tab_error: '{{count, number}} ข้อผิดพลาด',
    tab_error_other: '{{count, number}} ข้อผิดพลาด',
    skip_for_now: 'ข้ามตอนนี้',
    remove: 'นำออก',
    visit: 'เยี่ยมชม',
    join: 'เข้าร่วม',
    try_now: 'ลองใช้เลย',
    multiple_form_field: '(หลายรายการ)',
    demo: 'สาธิต',
    unnamed: 'ไม่มีชื่อ',
    view: 'ดู',
    open: 'เปิด',
    hide: 'ซ่อน',
    unknown_error: 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ กรุณาลองใหม่ภายหลัง',
    select: 'เลือก',
    contact_us_action: 'ติดต่อเรา',
    description: 'คำอธิบาย',
    name: 'ชื่อ',
    add_field: 'เพิ่ม{{field}}',
    create_field: 'สร้าง{{field}}',
    edit_field: 'แก้ไข{{field}}',
    delete_field: 'ลบ{{field}}',
    coming_soon: 'เร็ว ๆ นี้',
    or: 'หรือ',
    reset: 'รีเซ็ต',
    generate: 'สร้าง',
    manage: 'จัดการ',
};
export default Object.freeze(general);
